export const group = state => state.group.data
export const groupDone = state => state.group.done
export const groupError = state => state.group.error
export const groupPending = state => state.group.pending
export const groupWasDeleted = state => state.group.wasDeleted
export const user = state => state.auth.user
